/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Try_Text_PromptInputs */

const en_mcp_try_text_prompt = /** @type {(inputs: Mcp_Try_Text_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send the text below to Listening.`)
};

const es_mcp_try_text_prompt = /** @type {(inputs: Mcp_Try_Text_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envía el texto de abajo a Listening.`)
};

/**
* | output |
* | --- |
* | "Send the text below to Listening." |
*
* @param {Mcp_Try_Text_PromptInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_try_text_prompt = /** @type {((inputs?: Mcp_Try_Text_PromptInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Try_Text_PromptInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_try_text_prompt(inputs)
	return en_mcp_try_text_prompt(inputs)
});